import React from 'react';

import withoutInvoiceIcon from '@assets/icons/withoutInvoice.svg';

import {
  Container,
  WithoutInvoiceImage,
  WithoutInvoiceSubtitle,
  WithoutInvoiceTitle
} from './styles';

const WithoutInvoice: React.FC = () => {
  return (
    <Container>
      <WithoutInvoiceImage source={withoutInvoiceIcon} />
      <WithoutInvoiceTitle>Ainda não há lançamentos</WithoutInvoiceTitle>
      <WithoutInvoiceSubtitle>
        Você ainda não tem lançamentos para essa fatura. Assim que houver novas
        transações, nós apresentaremos aqui, ok?
      </WithoutInvoiceSubtitle>
    </Container>
  );
};

export default WithoutInvoice;
